import throttle from '@schibsted-nmp/search-frontend-utils/throttle.js';
import React from 'react';
import { useAppConfig } from '../../AppConfig';
import { FilterButton } from './FilterButton';
import { useMobileFilters } from './mobile-filters/MobileFiltersStore';
import { SelectedFilters } from './selected/SelectedFilters';

type FiltersToolbarProps = {
    className?: string;
    onOpen?: (filterName: string | null) => void;
};

export function FiltersToolbar(props: FiltersToolbarProps) {
    const { className, onOpen } = props;

    const [isSelectedFiltersScrolled, setIsSelectedFiltersScrolled] =
        React.useState(false);

    const [throttledAnimateFilterButton] = React.useMemo(
        () =>
            throttle((ev: React.UIEvent) => {
                const scrollLeft = (ev.target as HTMLElement).scrollLeft;
                setIsSelectedFiltersScrolled(scrollLeft > 0);
            }, 100),
        [setIsSelectedFiltersScrolled],
    );

    const { isProbablyMobile } = useAppConfig();

    const { setIsMobileFiltersOpen } = useMobileFilters();

    const showFilters = React.useCallback(() => {
        setIsMobileFiltersOpen(true);
        onOpen?.(null);
    }, [onOpen, setIsMobileFiltersOpen]);

    return isProbablyMobile ? (
        <div className={className}>
            <div
                className={`${
                    isSelectedFiltersScrolled ? 'sf-mobile-filters-button' : ''
                }`}
            >
                <FilterButton
                    collapsed={isSelectedFiltersScrolled}
                    onClick={showFilters}
                />
            </div>
            <SelectedFilters
                className="flex-nowrap grow space-x-8 -mr-16 pr-16 pl-8 overflow-x-scroll overscroll-x-none sf-no-scrollbar"
                onOpen={showFilters}
                onScroll={throttledAnimateFilterButton}
            />
        </div>
    ) : (
        <SelectedFilters
            className={className}
            filterClass="mr-8 mb-8"
            onOpen={onOpen}
            showReset={true}
        />
    );
}
